import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useDietaryPreferences } from 'providers/DietaryPreferenceProvider';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SelectPreferences, { PreferenceType } from '../SelectPreferences';
import ConfirmDialog from '../components/ConfirmDialog';
import ErrorAlert from '../components/ErrorAlert';
import Footer from './footer';
import Header from './header';
import Intro from './intro';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  currentPage: string;
  page: string;
}

const pages = ['home', 'diets', 'allergies'];

function TabPanel(props: TabPanelProps) {
  const { children, currentPage, page, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={page !== currentPage}
      id={`full-width-tabpanel-${pages.indexOf(page)}`}
      aria-labelledby={`full-width-tab-${pages.indexOf(page)}`}
      {...other}
    >
      {page === currentPage && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Onboarding() {
  const theme = useTheme();
  const hash = window.location.hash ? window.location.hash.substring(1) : 'home';
  const [currentPage, setCurrentPage] = React.useState(
    // if hash is in pages, set page to hash, otherwise set to 'home'
    pages.indexOf(hash) == -1 ? 'home' : hash
  );
  const [error, setError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const navigate: any = useNavigate();
  const { restaurantId } = useParams();
 
  const {
    selectedAllergies,
    selectedDiets,
  } = useDietaryPreferences();


  const handleChangeIndex = async (index: number) => {

    if (index > 2 && restaurantId) {
      setOpenDialog(true);
    } else {
      setCurrentPage(pages[index]);
    }
  };

  const checkConfirmation = (val: boolean, answer: boolean) => {
    if (answer && restaurantId) {
      navigate('/explore/'.concat(restaurantId, '/menu'));
    }
    setOpenDialog(val);
  };

  const getSelectedPreferencesCount = (page: string) => {
    if (page == 'diets') {
      return selectedDiets.length;
    } else if (page == 'allergies') {
      return selectedAllergies.length;
    } else {
      return 0;
    }
  };

  return (
    <Box
      height='100vh'
      display='flex'
      flexDirection='column'
      sx={{ backgroundColor: theme.palette.grey[0] }}
    >
      <Header
        changeStep={(val) => handleChangeIndex(pages.indexOf(val))}
        stepValue={pages.indexOf(currentPage)}
        selectedPreferencesCount={getSelectedPreferencesCount(currentPage)}
      />
      <Box sx={{ backgroundColor: theme.palette.grey[0], mt: 6 }}>
        {error && <ErrorAlert error={error} />}
        <TabPanel currentPage={currentPage} page={'home'} dir={theme.direction}>
          <Intro
            changeStep={(val) => handleChangeIndex(pages.indexOf(val))}
            stepValue={pages.indexOf(currentPage)}
          />
        </TabPanel>
        <TabPanel currentPage={currentPage} page={'diets'} dir={theme.direction}>
          <SelectPreferences preferenceType={PreferenceType.diet} />
        </TabPanel>
        <TabPanel currentPage={currentPage} page={'allergies'} dir={theme.direction}>
          <SelectPreferences preferenceType={PreferenceType.allergy} />
        </TabPanel>
        {openDialog && (
          <ConfirmDialog
            setOpenDialog={(val: boolean, answer: boolean) =>
              checkConfirmation(val, answer)
            }
            openDialog={openDialog}
          />
        )}
        <Footer
          changeStep={(val) => handleChangeIndex(val)}
          tab={pages.indexOf(currentPage)}
          selectedPreferencesCount={getSelectedPreferencesCount(currentPage)}
        />
      </Box>
    </Box>
  );
}
